/* eslint-disable react/prop-types */

/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { Provider } from 'react-redux';
import { createStore, combineReducers } from 'redux'; // @ts-ignore - no types available

import { reducer as impressions } from '@nerdwallet/nw-client-lib/tracking';
/**
 * ApplyNowImpressionWrapper is used for tests and storybook to provide
 * a mock provider for Apollo and provider for redux for legacy instrumentation
 */

var ApplyNowImpressionWrapper = function ApplyNowImpressionWrapper(_ref) {
  var children = _ref.children;
  var impressionStore = createStore(combineReducers({
    impressions: impressions
  }));
  return /*#__PURE__*/React.createElement(Provider, {
    store: impressionStore
  }, children);
};

ApplyNowImpressionWrapper.displayName = 'ApplyNowImpressionWrapper';
ApplyNowImpressionWrapper.propTypes = {};
export default ApplyNowImpressionWrapper;